import ReceiptForm from "./form";
import ReceiptAction from "./receipt-action";
import SettleDueForm from "./settle-due-form";
import ViewAllReceipts from "./view-all-receipts";

export default function ReceiptV2() {
  return (
    <>
      <ReceiptAction />
      <ReceiptForm />
      <ViewAllReceipts />
      <SettleDueForm />
    </>
  );
}
